import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import * as fromRoot from "@core/store/reducers";
import { Settings } from "@core/store/settings/settings.model";
import * as SettingsActions from "@core/store/user/user.actions";
import { Router } from "@angular/router";
import { FileSystemFileEntry, UploadEvent } from "ngx-file-drop";
import { NotificationsService } from "angular2-notifications";
import { environment } from "@env/environment";
import { CurrencyService } from "@core/services/currency.service";

@Component({
  selector: "app-configuration-wizard",
  templateUrl: "./configuration-wizard.component.html",
  styleUrls: ["./configuration-wizard.component.scss"],
})
export class ConfigurationWizardComponent implements OnInit {
  @ViewChild("fileInput") fileInput;

  public form: FormGroup;
  public currencies: Object;
  public logo;
  public logoUrl: string;

  objectKeys = Object.keys;

  supportedLanguages = environment.SUPPORTED_LANGUAGES;

  constructor(
    private formBuilder: FormBuilder,
    private store: Store<fromRoot.AppState>,
    private router: Router,
    private notificationService: NotificationsService,
    private currencyService: CurrencyService,
  ) {
    this.createForm();

    this.store
      .select(fromRoot.getSettings)
      .filter((settings) => settings !== null)
      .subscribe((settings) => this.loadForm(settings));

    this.currencies = this.currencyService.getCurrencies();
  }

  ngOnInit() {}

  createForm() {
    this.form = this.formBuilder.group({
      name: ["", Validators.required],
      contactInfo: "",
      currency: ["", Validators.required],
      numberingSystem: ["", Validators.required],
      language: ["", Validators.required],
    });
  }

  loadForm(settings: Settings) {
    this.form.patchValue({
      name: settings.name,
      contactInfo: settings.contactInfo,
      currency: settings.currency,
      numberingSystem: settings.numberingSystem,
      language: settings.language,
    });

    if (settings.logo) {
      this.logoUrl = settings.logo;
    }
  }

  save(data) {
    if (this.logo) {
      data.logoFile = this.logo;
    }

    this.store.dispatch(new SettingsActions.SaveSettingsAction(data));
    this.router.navigate(["/dashboard"]);
  }

  public dropped(event: UploadEvent) {
    const droppedFile = event.files[0];

    // Is it a file?
    if (droppedFile.fileEntry.isFile) {
      const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
      fileEntry.file((file: File) => {
        this.addLogo(file);
      });
    }
  }

  public uploadLogo() {
    const fi = this.fileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      this.addLogo(fi.files[0]);
    }
  }

  private addLogo(file: File) {
    const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
    if (!allowedExtensions.exec(file.name)) {
      this.notificationService.error(
        "File not supported",
        "Only jpeg and png images are allowed",
      );
      return false;
    }

    this.logo = file;

    const reader = new FileReader();

    reader.onload = (event: any) => {
      this.logoUrl = event.target.result;
    };

    reader.readAsDataURL(file);
  }
}



// WEBPACK FOOTER //
// /app/src/app/settings/pages/configuration-wizard/configuration-wizard.component.ts